import React from "react";

// Minimal and tiny UI element for showing the build SHA
const BuildInfo: React.FC = () => {
  // Read the GIT_SHA from a variety of places to maximize visibility across build setups
  // Prefer the explicit REACT_APP var (CRA), then GIT_SHA, and fallback to window var that may be injected
  const gitSha =
    (process && (process.env as any).REACT_APP_GIT_SHA) ||
    (process && (process.env as any).GIT_SHA) ||
    (typeof window !== "undefined" && (window as any).GIT_SHA) ||
    "unknown"

  // short version to keep the UI small
  const MAX_SHA_LENGTH = 25;
  const shortSha = gitSha && gitSha.length > MAX_SHA_LENGTH ? gitSha.slice(0, MAX_SHA_LENGTH) : gitSha

  const style: React.CSSProperties = {
    position: "fixed",
    right: "8px",
    bottom: "8px",
    padding: "4px 8px",
    fontSize: "9px",
    zIndex: 9999,
    opacity: 0.6,
    pointerEvents: "none", // keep it non-interactive
  }

  return (
    <div style={style} title={gitSha} aria-hidden={false}>
      <span style={{ fontWeight: 500 }}>version</span>
      <span style={{ marginLeft: 6, fontFamily: "monospace", color: "#0f87c3" }}>{shortSha}</span>
    </div>
  )
}

export default BuildInfo;
